__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host-template";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.4", function() { return __webpack_require__.e(3733).then(function() { return function() { return __webpack_require__(13733); }; }); });
			register("next/dynamic", "13.4.9", function() { return __webpack_require__.e(6172).then(function() { return function() { return __webpack_require__(76172); }; }); });
			register("next/head", "13.4.9", function() { return __webpack_require__.e(5283).then(function() { return function() { return __webpack_require__(65283); }; }); });
			register("next/image", "13.4.9", function() { return __webpack_require__.e(6292).then(function() { return function() { return __webpack_require__(16292); }; }); });
			register("next/link", "13.4.9", function() { return __webpack_require__.e(3821).then(function() { return function() { return __webpack_require__(33821); }; }); });
			register("next/router", "13.4.9", function() { return __webpack_require__.e(5286).then(function() { return function() { return __webpack_require__(40664); }; }); });
			register("next/script", "13.4.9", function() { return __webpack_require__.e(9642).then(function() { return function() { return __webpack_require__(9642); }; }); });
			register("react-dom/client", "18.2.0", function() { return __webpack_require__.e(8088).then(function() { return function() { return __webpack_require__(48088); }; }); });
			register("react-dom/server", "18.2.0", function() { return __webpack_require__.e(9906).then(function() { return function() { return __webpack_require__(49906); }; }); });
			register("react-dom", "18.2.0", function() { return __webpack_require__.e(8884).then(function() { return function() { return __webpack_require__(41615); }; }); });
			register("react/jsx-runtime", "18.2.0", function() { return __webpack_require__.e(3274).then(function() { return function() { return __webpack_require__(13274); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(1933).then(function() { return function() { return __webpack_require__(79474); }; }); });
			register("styled-jsx/style", "5.1.1", function() { return __webpack_require__.e(8890).then(function() { return function() { return __webpack_require__(88890); }; }); });
			register("styled-jsx", "5.1.1", function() { return __webpack_require__.e(9735).then(function() { return function() { return __webpack_require__(89735); }; }); });
			initExternal(90806);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};